













import { Component, Vue } from "vue-property-decorator";

import BreadcrumbList from "@/components/common/breadcrumb/BreadcrumbList.vue";
import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";
import PageMain from "@/components/pages/parts/PageMain.vue";

@Component({
  components: { PageMain, FlexibleContentArea, BreadcrumbList },
})
export default class AccessErrorPage extends Vue {
  mounted(): void {
    this.hideLoading();
  }
}
